











import { Component, Vue } from "vue-property-decorator";

@Component
export default class FullscreenButton extends Vue {
    public fullscreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    }
}
